"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (window) {
  var ProductCardUtils = /*#__PURE__*/function () {
    function ProductCardUtils() {
      _classCallCheck(this, ProductCardUtils);
    }

    _createClass(ProductCardUtils, null, [{
      key: "getPictures",
      value: function getPictures(imagesMap, isOnlyShoesGrid, isAShoe) {
        var urls = ['', ''];
        /***************************************************************
             picture[String] = '../../.jpg' -> Unica url
            picture[Object] = {
                default[String]: '../../.jpg' -> Unica url, [
                    "--xxs[String]": '../../.jpg' -> Unica specifica per xxs
                    "--sm[String]": '../../.jpg' -> Unica specifica per sm
                ]
            }
             SIZE MAP: ["--xxs", "--xs", "--sm", "--md", "--lg", "--xl", "--xxl", "--xxxl", "--xxxxl"]
         ***************************************************************/

        if (imagesMap.length) {
          var EXISTS_TTT1 = imagesMap[0].match('-ttt1') != null;
          var EXISTS_TTT2 = imagesMap[2] && imagesMap[2].match('-ttt2') != null;
          urls[0] = imagesMap[0];
          urls[1] = imagesMap[0];

          if (imagesMap[1]) {
            urls[1] = imagesMap[1];
          }
          /* if (isOnlyShoesGrid) {
              urls[0] = {
                  default: imagesMap[0]
              };
              urls[1] = {
                  default: imagesMap[0]
              };
              if (EXISTS_TTT1 && EXISTS_TTT2) {
                  if (imagesMap.length > 1) {
                      urls[0] = {
                          default: imagesMap[1],
                          "--xxs": imagesMap[0],
                          "--xs": imagesMap[0],
                          "--sm": imagesMap[0]
                      };
                  }
                  if (imagesMap.length > 3) {
                      urls[1] = {
                          default: imagesMap[3],
                          "--xxs": imagesMap[2],
                          "--xs": imagesMap[2],
                          "--sm": imagesMap[2]
                      };
                  }
              } else if (!EXISTS_TTT1 && !EXISTS_TTT2) {
                  if (imagesMap[1]) {
                      urls[1].default = imagesMap[1];
                  }
              } else if (EXISTS_TTT1 && !EXISTS_TTT2) {
                  if (imagesMap[1]) {
                      urls[0].default = imagesMap[1];
                  }
                  if (imagesMap[2]) {
                      urls[1].default = imagesMap[2];
                  }
              } else {
                  if (imagesMap[2]) {
                      urls[1].default = imagesMap[2];
                  }
              }
          } else {
              if (isAShoe) {
                  if (imagesMap[1]) {
                      urls[0] = imagesMap[1];
                  }
                  if (imagesMap[3]) {
                      urls[1] = imagesMap[3];
                  }
              } else {
                  if (imagesMap[1]) {
                      urls[1] = imagesMap[1];
                  }
              }
          } */

        }

        return urls;
      }
    }, {
      key: "getSizesMap",
      value: function getSizesMap(data) {
        var SIZEMAP_CODE_ARRAY = _.filter(data.tags, function (el) {
          return el.match('sizemapcode[0-9]');
        });

        var result = {
          schema: null,
          sizes: null,
          indexes: null
        };

        for (var i = 0; i < SIZEMAP_CODE_ARRAY.length; i++) {
          if (typeof SIZEMAP_CODE_ARRAY[i] == 'string') {
            var SIZEMAP_CODE = SIZEMAP_CODE_ARRAY[i].replace('sizemapcode' + i + '_', '');

            if (window.theme.sizemap[SIZEMAP_CODE]) {
              var checkEmpty = window.theme.sizemap[SIZEMAP_CODE].map.filter(function (el) {
                return el == '';
              });
              result.schema = window.theme.sizemap[SIZEMAP_CODE].map;
              result.sizes = window.theme.sizemap[SIZEMAP_CODE].sizes;
              result.indexes = window.theme.sizemap[SIZEMAP_CODE].indexes;
            } else {//console.log('%c-> This sizemap code [' + SIZEMAP_CODE + '] is not in the sizemap.', 'color: #e2cb00; font-weight:bold;', window.theme.sizemap[SIZEMAP_CODE], [data.vendor, data.title, data.id]);
            }
          } else {
            console.log('%c-> This items has an invalid sizemapcode tag at index ' + i, 'color: red; font-weight:bold;', SIZEMAP_CODE, [tags, data.vendor, data.title, data.id]);
          }

          if (result.sizes) {
            break;
          }
        }

        return result;
      }
    }, {
      key: "getItemState",
      value: function getItemState(data) {
        var restocked = data.tags.indexOf("restocked") > -1;
        var new_coming_soon = tags.indexOf("new_coming_soon") > -1;
        var no_show_discount = data.tags.indexOf("no_show_discount") > -1;
        var time_of_publishing = (new Date(data.published_at).getTime() / 1000).toFixed(0);
        var time_now = Math.round(new Date().getTime() / 1000).toFixed(0);
        var state = {
          value: '',
          txt: ''
        };

        if (new_coming_soon == true) {
          state.value = 'coming soon';
          state.txt = 'coming soon';
        } else if (data.available == false) {
          state.value = 'sold out';
          state.txt = 'sold out';
        } else if (out_flag == true && count_out == 1) {
          state.value = 'out of stock';
          state.txt = window.theme.strings.products.product.single_out_of_stock;

          if (range_is_selected == true) {
            state.txt = window.theme.strings.products.product.multiple_out_of_stock;
          }
        } else if (out_flag == true && count_out > 1) {
          state.value = 'out of stock';
          state.txt = window.theme.strings.products.product.multiple_out_of_stock;
        } else if (compare_at_price_min > price_min) {
          if (no_show_discount == true) {} else {
            state.value = 'sale';
            state.txt = 'sale';
          }
        } else if (time_now - time_of_publishing < 3888000) {
          state.value = 'new';
          state.txt = 'new';
        } else if (restocked == true) {
          state.value = 'restocked';
          state.txt = 'restocked';
        }

        return state;
      }
    }]);

    return ProductCardUtils;
  }();

  window.ProductCardUtils = ProductCardUtils;
})(window);
